<template>
  <form @submit.prevent="submit">
    <md-card>
      <md-card-header data-background-color="primary">
        <h4 class="title">Abertura de atendimento</h4>
        <p class="category">Preencha os campos abaixo</p>
      </md-card-header>

      <md-card-content>
        <h4 class="title">Dados Pessoais</h4>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Nome</label>
              <md-input v-model="payload.name" required></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Sua relação com o assinante</label>
              <md-select
                v-model="payload.relationship"
                name="relationship"
                placeholder="Sua relação com o assinante"
                required
              >
                <md-option value="1">Assinante</md-option>
                <md-option value="2">Esposa(o)</md-option>
                <md-option value="3">Filho(a)</md-option>
                <md-option value="4">Pai/Mãe</md-option>
                <md-option value="5">Outro Parente</md-option>
                <md-option value="6">Funcionário</md-option>
                <md-option value="7">Outros</md-option>
                <md-option value="8">Colega de Trabalho</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>E-mail</label>
              <md-input v-model="payload.email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Telefone com DDD</label>
              <md-input
                v-model="payload.phone"
                v-mask="'##-#########'"
              ></md-input>
            </md-field>
          </div>

          <h4 class="title">Chamado</h4>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Tipo de Atendimento</label>
              <md-select
                v-model="payload.type"
                name="relationship"
                placeholder="Tipo de Atendimento"
                required
              >
                <md-option value="10024">Atendimento Web</md-option>
                <md-option value="10010"
                  >Problema Central do Assinante</md-option
                >
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Assunto</label>
              <md-input v-model="payload.title" max="60" required></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Descrição do problema</label>
              <md-textarea v-model="payload.description" required></md-textarea>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100 text-right">
            <md-button type="submit" class="md-raised btn">
              Enviar
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "ticket-form",
  data() {
    return {
      isLoading: false,
      payload: {
        name: null,
        relationship: null,
        email: null,
        phone: null,
        type: null,
        title: null,
        description: null
      }
    };
  },
  methods: {
    ...mapActions(["createTicket"]),
    async submit() {
      if (this.isLoading) {
        return;
      }

      try {
        this.isLoading = true;
        await this.createTicket({ payload: this.payload });
        Swal.fire("Sucesso!", "O atendimento foi criado.", "success");
        this.$router.push("/tickets");
      } catch (err) {
        if (err.response) {
          if (err.response.status === 400) {
            Swal.fire(
              "Ops!",
              "Não foi possível criar o atendimento, verifique os campos digitados.",
              "error"
            );
          } else {
            Swal.fire(
              "Ops!",
              "Houve algum problema ao criar o atendimento.",
              "error"
            );
          }
        } else {
          Swal.fire(
            "Ops!",
            "Não foi possível conectar com o servidor.",
            "error"
          );
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.btn {
  background-color: var(--primary-color) !important;
}
.btn:hover {
  background-color: var(--secondary-color) !important;
}
</style>
